import Routes from "./routes";
import ChatButton from "./components/ui/ChatButton/ChatButton";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <div className="bg-[#f6f8f6] overflow-x-hidden">
        <Routes />
        <ChatButton />
      </div>
    </HelmetProvider>
  );
}

export default App;
